// extracted by mini-css-extract-plugin
export default {"root":"ModalHeader_root__gMFkV","title":"ModalHeader_title__uQ+vE","tip":"ModalHeader_tip__AB8BM"};